// automatically generated by the FlatBuffers compiler, do not modify
export var DateUnit;
(function (DateUnit) {
    DateUnit[DateUnit["DAY"] = 0] = "DAY";
    DateUnit[DateUnit["MILLISECOND"] = 1] = "MILLISECOND";
})(DateUnit || (DateUnit = {}));

//# sourceMappingURL=date-unit.mjs.map
